import { render } from "./hr-footer-message.vue?vue&type=template&id=d2f789f4&scoped=true"
import script from "./hr-footer-message.vue?vue&type=script&lang=js"
export * from "./hr-footer-message.vue?vue&type=script&lang=js"

import "./hr-footer-message.vue?vue&type=style&index=0&id=d2f789f4&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f789f4"]])

export default __exports__